/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Icon } from '@zapier/zinnia-icons';
import { Colors, Grid, Text } from '@zapier/design-system';

import LinkWithArrow from 'app/developer-v3/components/LinkWithArrow';
import {
  TABS as SIDEBAR_RIGHT_TABS,
  VERSIONING_SECTION_IDS,
  useSidebarRight,
} from 'app/developer-v3/components/SidebarRight';

import Styles from '../CTAVersioning.styles';

type Props = {
  versionFrom: string;
  versionTo: string;
};

function Progress(props: Props) {
  const { versionFrom, versionTo } = props;

  const { update: updateSidebarRight } = useSidebarRight();

  return (
    <div css={Styles.root(Colors.Blue1)}>
      <Grid columns="24px auto" gap={20}>
        <Icon color="Blue3" name="miscUptime" size={24} />
        <div>
          <Text fontWeight={600} tag="h2" type="Body4">
            Migrating integration version
          </Text>
          <Text margin="10px 0px 0px" tag="p">
            We’re migrating your integration version {versionFrom} to{' '}
            {versionTo}. View the progress in the{' '}
            <LinkWithArrow
              onClick={() =>
                updateSidebarRight({
                  tabActive: SIDEBAR_RIGHT_TABS.VERSIONING,
                  activeSubsection: VERSIONING_SECTION_IDS.MIGRATE,
                })
              }
            >
              side panel
            </LinkWithArrow>
            .
          </Text>
        </div>
      </Grid>
    </div>
  );
}

export default Progress;
